import { getPatterns } from "./colourizer.js";
import { patternMatchesKey } from "../components/Panel";
import { expandRange } from "./panel";

const settings = window.settings;

/**
 * Take the json string from the db and turn it into a usable list
 *
 * @param jsonString
 * @returns {[]}
 */
export function deserializeTemperatureCurves(jsonString) {
  const curves = [];

  for (const curve of JSON.parse(jsonString)) {
    try {
      const degreesPerGreyscalePixel =
        Math.abs(curve.value.black - curve.value.white) / 255;
      let scale = {};

      for (let i = 0; i <= 255; i++) {
        const differenceInDegrees = i * degreesPerGreyscalePixel;
        // Because the scale goes from a high temperature with lower greyscale values to lower
        // temperatures at higher greyscale values, this looks a bit unintuitive
        scale[i] = curve.value.black - differenceInDegrees;
      }

      // If there are values to ignore, set them to null
      if (curve.value.ignore) {
        for (let key of curve.value.ignore) {
          if (key.indexOf("-") === -1) {
            scale[Number.parseInt(key, 10)] = null;
          } else {
            for (let i of expandRange(key)) {
              scale[i] = null;
            }
          }
        }
      }
      curves.push({
        pattern: getPatterns(curve.pattern),
        scale: scale
      });
    } catch (error) {
      console.error(error);
    }
  }
  return curves;
}

// Lookup the temperaturescale for the given Panel Image geography.
// These scales are rendered in the document by the server.
export function getScaleForKey(compositeKey) {
  if (
    !settings ||
    !settings.workspace ||
    !settings.workspace.temperatureCurves
  ) {
    return null;
  }

  try {
    const curve = settings.workspace.temperatureCurves.find(c => {
      return patternMatchesKey(c.pattern, compositeKey);
    });

    if (curve) {
      return curve.scale;
    }
  } catch (error) {
    console.error(error);
  }

  return null;
}
